import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { SortOption } from 'globals/store/user.data';

@Component({
    selector: 'sort-select',
    template: `
<div class="sorting" [matMenuTriggerFor]="sorting">
  <span *ngIf="!!showLabel">Sort:</span>
  <icon class="secondary" [icon]="sortOption?.event_order_rev ? 'sort_up_18px' : 'sort_down_18px'"></icon>
  <span class="secondary">{{ sortOptionsMap[sortOption?.event_order_key] }}</span>
  <mat-icon>arrow_drop_down</mat-icon>
</div>
<mat-menu #sorting="matMenu" xPosition="before" class="sorting-options-panel">
  <div class="sort-option" [ngClass]="{ selected: opt.event_order_key === sortOption.event_order_key && opt.event_order_rev === sortOption.event_order_rev }" *ngFor="let opt of sortOptions" (click)="selectSortOption.emit(opt)">
    <icon [icon]="opt.event_order_rev ? 'sort_up_18px' : 'sort_down_18px'"></icon>
    {{ sortOptionsMap[opt.event_order_key] }}
  </div>
</mat-menu>
`,
    styleUrls: ['./sort-select.scss'],
    standalone: true,
    imports: [IconComponent, MatMenuModule, MatIconModule, CommonModule],
})
export class SortSelectComponent  {
  @Input() showLabel = false
  sortOptions: SortOption[] = [
    { event_order_key: 'first_date', event_order_rev: true },
    { event_order_key: 'first_date', event_order_rev: false },
    { event_order_key: 'title', event_order_rev: true },
    { event_order_key: 'title', event_order_rev: false },
  ]
  @Input() sortOptionsMap = { 'first_date': 'Date', 'title': 'Name' }
  @Input() sortOption: SortOption // takes an input or automatically gets from user settings for home dashboard sorting
  @Output() selectSortOption: EventEmitter<SortOption> = new EventEmitter()

}
